// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"844":"40bfb985606b67c5","895":"bde01f7d76df312a","6321":"97f73f807f41b2df"}[chunkId] + ".css";
};